import { useSelectDocumentTableColumnInfo } from './ColumnInfo';
import { DataTable } from '@/Components/DataTable/DataTable';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DocumentInfoForEmailModel } from '@/Models/DocumentInfoModel';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';
import { emailSendModalActions } from '@/ModalWindows/EmailSendModal/services/reducer';

export function SelectDocumentTable() {
  const dispatch = useDispatch();

  const columnInfos = useSelectDocumentTableColumnInfo();
  const documentNumbersInfo = useSelector(emailSendModalSelectors.documentNumbersInfo);

  return useMemo(
    () => (
      <DataTable<DocumentInfoForEmailModel>
        rows={documentNumbersInfo}
        rowKey={'documentNumber'}
        columnInfos={columnInfos}
        filterOptions={{
          needShowFiltersButton: false,
          needHeaderFilter: false,
          needColumnChooser: false,
          showFilterBuilder: false,
          needGlobalSearchPanel: false,
          needClearFiltersButton: false,
        }}
        editOptions={{
          needEditing: false,
        }}
        selectOptions={{
          showCheckBoxesMode: 'onClick',
          onSelectedRowsChanged(data) {
            dispatch(emailSendModalActions.setSelectedDocumentNumbers(data.map((item) => item.documentNumber)));
          },
        }}
        defaultOptions={{
          showPagination: false,
        }}
        exportOptions={{
          needExport: false,
          exportFileName: '',
        }}
      />
    ),
    [documentNumbersInfo],
  );
}
